import React, { useEffect, useRef } from "react";
import { Bold, Italic, Heading, List, ListOrdered } from "lucide-react";

// Éditeur de texte riche léger basé sur contentEditable (fiable, sans dépendance).
// initialHtml : HTML initial. onChange(html) à chaque modification.
const RichTextEditor = ({ initialHtml, onChange }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.innerHTML = initialHtml || "";
    // on n'initialise qu'au montage (composant remonté via `key` quand on change de bloc)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = () => {
    if (onChange && ref.current) onChange(ref.current.innerHTML);
  };

  const exec = (command, value) => {
    document.execCommand(command, false, value);
    if (ref.current) ref.current.focus();
    emit();
  };

  const tool = (cmd, value, label, Icon) => (
    <button
      type="button"
      className="rte-btn"
      title={label}
      // mousedown + preventDefault : conserve la sélection dans l'éditeur au clic
      onMouseDown={(e) => {
        e.preventDefault();
        exec(cmd, value);
      }}
    >
      <Icon size={15} />
    </button>
  );

  return (
    <div className="rte">
      <div className="rte-toolbar">
        {tool("bold", null, "Gras", Bold)}
        {tool("italic", null, "Italique", Italic)}
        {tool("formatBlock", "h3", "Titre", Heading)}
        {tool("insertUnorderedList", null, "Liste à puces", List)}
        {tool("insertOrderedList", null, "Liste numérotée", ListOrdered)}
      </div>
      <div
        ref={ref}
        className="rte-content"
        contentEditable
        suppressContentEditableWarning
        onInput={emit}
      />
    </div>
  );
};

export default RichTextEditor;
